import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import ReactTooltip from 'react-tooltip';
import {MealTypes} from '../../../server/constants';
import {groupBy} from "../../../server/util";
import moment from 'moment'

class OrdersTable extends Component {
    render() {
        const {schoolList,tableView, data}=this.props;
        const schoolListObj=groupBy(schoolList,'schoolId');
        const {selectedDates}=this.props.data
        return (
            <div className="col-md-12">
                <div className="panel chart-panel" style={{height:'auto'}}>
                <div className="panel-heading text-center">
                    <span className="panel-title" style={{fontSize: '14px', fontWeight:'600'}}>
                        {
                        tableView=='DAY'?'Current Day Orders':
                        tableView=='WEEK'?'Current Week Orders':
                        tableView=='MONTH'?'Current Month Orders':
                        null}</span>
                </div>
                <div className="panel-body" style={{padding:'0px'}}>                    
                    <ReactTable
                        data={Object.keys((data||{}).summary||{}).map(schoolId=>{
                            return {
                                schoolId:schoolId, schoolName:(schoolListObj[schoolId][0]||{}).schoolName, count: Object.values(data.summary[schoolId]||{}).reduce((sum, x) => sum + x)
                            }
                        })}
                        
                        columns={[
                            {
                                Header: "School",
                                Cell:props=>{
                                    return <a role="button" href="javascript:void(0)" onClick={(e)=>{
                                        this.props.onSchoolClick(props.original.schoolId);
                                    }}><span>{props.original.schoolName}</span></a>
                                }
                            },
                            { Header: "Count", width: 150, accessor: "count" }
                            ]}
                        defaultPageSize={10}
                        className="-striped -highlight rtTable-Order"
                        noDataText='No data found'
                        showPagination={true}
                    />
                </div>                
            </div>
        </div>
        );
    }
}
export default OrdersTable;


// WEBPACK FOOTER //
// ./src/components/Caterer/Orders/ordersTable.jsx